// userAction.js
import { backendClient } from "../../api/backend";
import i18n from "../../i18n";
import { setTheme } from "./themeActions";
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  UPDATE_PROMPT_REQUEST,
  UPDATE_PROMPT_SUCCESS,
  UPDATE_PROMPT_FAILURE,
  FETCH_PROMPTS_REQUEST,
  FETCH_PROMPTS_SUCCESS,
  FETCH_PROMPTS_FAILURE,
  FETCH_LANGUAGE_PREFERENCES_REQUEST,
  FETCH_LANGUAGE_PREFERENCES_SUCCESS,
  FETCH_LANGUAGE_PREFERENCES_FAILURE,
  UPDATE_LANGUAGE_PREFERENCES_REQUEST,
  UPDATE_LANGUAGE_PREFERENCES_SUCCESS,
  UPDATE_LANGUAGE_PREFERENCES_FAILURE,
  UPDATE_COUNTRY_PREFERENCE,
  UPDATE_JURISDICTION_PREFERENCE,
  SET_JURISDICTION_TREE,
  FETCH_APP_PREFERENCES_REQUEST,
  FETCH_APP_PREFERENCES_SUCCESS,
  FETCH_APP_PREFERENCES_FAILURE,
  UPDATE_APP_PREFERENCES_REQUEST,
  UPDATE_APP_PREFERENCES_SUCCESS,
  UPDATE_APP_PREFERENCES_FAILURE,
  SET_SEARCH_MODE,
} from "../actions/types";



export const fetchUsersByOrganization =
  (organizationId) => async (dispatch) => {
    dispatch({ type: FETCH_USERS_REQUEST });

    try {
      const users = await backendClient.fetchUsersByOrganization(
        organizationId
      );
      dispatch({
        type: FETCH_USERS_SUCCESS,
        payload: users,
      });
    } catch (error) {
      dispatch({
        type: FETCH_USERS_FAILURE,
        payload: error.message,
      });
    }
  };

export const fetchPrompts = (userId, promptType) => async (dispatch) => {
  dispatch({ type: FETCH_PROMPTS_REQUEST });

  try {
    const prompts = await backendClient.getPrompt(userId, promptType);
    dispatch({
      type: FETCH_PROMPTS_SUCCESS,
      payload: prompts,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROMPTS_FAILURE,
      payload: error.message,
    });
  }
};
export const updatePrompt = (userId, type, promptText) => async (dispatch) => {
  dispatch({ type: UPDATE_PROMPT_REQUEST });

  try {
    const updatedPrompt = await backendClient.updatePrompt(
      userId,
      type,
      promptText
    );
    dispatch({
      type: UPDATE_PROMPT_SUCCESS,
      payload: updatedPrompt,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PROMPT_FAILURE,
      payload: error.message,
    });
  }
};

// Fetch language preferences
export const fetchLanguagePreferences = () => async (dispatch) => {
  dispatch({ type: FETCH_LANGUAGE_PREFERENCES_REQUEST });
  
  try {
    const preferences = await backendClient.getLanguagePreferences();
    dispatch({
      type: FETCH_LANGUAGE_PREFERENCES_SUCCESS,
      payload: preferences,
    });
    return preferences;
  } catch (error) {
    dispatch({
      type: FETCH_LANGUAGE_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Update language preferences
export const updateLanguagePreferences = (preferences) => async (dispatch) => {
  dispatch({ type: UPDATE_LANGUAGE_PREFERENCES_REQUEST });
  
  try {
    const updatedPreferences = await backendClient.updateLanguagePreferences(preferences);
    dispatch({
      type: UPDATE_LANGUAGE_PREFERENCES_SUCCESS,
      payload: updatedPreferences,
    });
    return updatedPreferences;
  } catch (error) {
    dispatch({
      type: UPDATE_LANGUAGE_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Update country preference
export const updateCountryPreference = (country) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_COUNTRY_PREFERENCE,
      payload: country,
    });
    return country;
  } catch (error) {
    console.error("Failed to update country preference:", error);
    throw error;
  }
};

// Update jurisdiction preference for a country
// jurisdictionCodes = null means "all" (no filter), array = specific selection
export const updateJurisdictionPreference = (countryCode, jurisdictionCodes) => ({
  type: UPDATE_JURISDICTION_PREFERENCE,
  payload: { countryCode, jurisdictionCodes },
});

// Fetch jurisdiction tree from backend
export const fetchJurisdictionTree = (countryCode) => async (dispatch, getState) => {
  const state = getState()
  const existing = state.user?.jurisdictionTrees?.[countryCode]
  if (existing) return existing // Already cached

  try {
    const data = await backendClient.getJurisdictionTree(countryCode)
    dispatch({
      type: SET_JURISDICTION_TREE,
      payload: { countryCode, data },
    })
    return data
  } catch (error) {
    console.error('Failed to fetch jurisdiction tree:', error)
    return null
  }
};

// Fetch app preferences
export const fetchAppPreferences = () => async (dispatch) => {
  dispatch({ type: FETCH_APP_PREFERENCES_REQUEST });
  try {
    const preferences = await backendClient.getAppPreferences();
    dispatch({
      type: FETCH_APP_PREFERENCES_SUCCESS,
      payload: preferences,
    });
    if (preferences?.app_language) {
      i18n.changeLanguage(preferences.app_language);
    }
    if (preferences?.theme_mode) {
      dispatch(setTheme(preferences.theme_mode));
    }
    return preferences;
  } catch (error) {
    dispatch({
      type: FETCH_APP_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Update app preferences
export const updateAppPreferences = (preferences) => async (dispatch) => {
  dispatch({ type: UPDATE_APP_PREFERENCES_REQUEST });
  try {
    const updatedPreferences = await backendClient.updateAppPreferences(preferences);
    dispatch({
      type: UPDATE_APP_PREFERENCES_SUCCESS,
      payload: updatedPreferences,
    });
    return updatedPreferences;
  } catch (error) {
    dispatch({
      type: UPDATE_APP_PREFERENCES_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// Chat preferences action creators
export const setSearchMode = (mode) => ({
  type: SET_SEARCH_MODE,
  payload: mode,
});
